import { handleActions, combineActions } from 'redux-actions';
import { Map } from 'immutable';

import actions from '@synergycms_app/store/actions';

//REDUCERS
const { params } = actions.customer;
export default handleActions(
  {
    [combineActions(params.availCacheParams.toString(), params.createFromUrl.toString(), params.updateParams.toString())]: (params, { payload }) => {
      return params.merge(payload);
    }
  },
  Map({
    validParams: null,
    url_params: null,
    params: null,
    query_params: null
  })
);
